export function formatDateForApi(value: string) {
  const [month, day, year] = value.split('/')

  if (!month || !day || !year || year.length !== 4) {
    return undefined
  }

  const normalizedMonth = month.padStart(2, '0')
  const normalizedDay = day.padStart(2, '0')

  return `${year}-${normalizedMonth}-${normalizedDay}`
}

export function formatTransmissionForApi(value: string) {
  switch (value) {
    case 'automatic':
      return 'AUTOMATIC'
    case 'manual':
      return 'MANUAL'
    default:
      return undefined
  }
}
